* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

// Disable the default spacing of the columns
gz-basic-table::part(row) {
  gap: 0;
}

// Make the first and the last columns fit their contents
gz-basic-table::part(column-0),
gz-basic-table::part(column-3) {
  flex: 0 0 auto;
}

// The first column (the one with the icon) should be closer
// to the next column (the one with the text) than the rest
gz-basic-table::part(column-1) {
  margin-left: calc(var(--spacer) * 0.5);
}

// Spacing for the rest of the columns
gz-basic-table::part(column-2),
gz-basic-table::part(column-3) {
  margin-left: calc(var(--spacer) * 2);
}

// Stretch the last column to align the text properly
gz-basic-table::part(column-3) {
  min-width: calc(var(--spacer) * 4);
}

gz-link {
  padding-top: calc(var(--spacer) * 10);
}
